import { useEffect } from "react"

/**
 * Collapse the left sidebar to icon ("mobile") mode while a dashboard is mounted — the wide
 * charts/cards get the extra horizontal space. Restores the expanded menu on leave, and never
 * fights a menu the user had already collapsed manually (leaves it as-is in that case).
 */
export default function useCollapsedSidebar() {
  useEffect(() => {
    const body = document.body
    const alreadyCollapsed = body.classList.contains("vertical-collpsed")
    if (!alreadyCollapsed) body.classList.add("vertical-collpsed")
    return () => {
      // only undo what we added — if it was collapsed before we mounted, leave it collapsed
      if (!alreadyCollapsed) body.classList.remove("vertical-collpsed")
    }
  }, [])
}
